import { render, staticRenderFns } from "./promotion_rule.vue?vue&type=template&id=62aaf1c3&scoped=true"
import script from "./promotion_rule.vue?vue&type=script&lang=js"
export * from "./promotion_rule.vue?vue&type=script&lang=js"
import style0 from "./promotion_rule.vue?vue&type=style&index=0&id=62aaf1c3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aaf1c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62aaf1c3')) {
      api.createRecord('62aaf1c3', component.options)
    } else {
      api.reload('62aaf1c3', component.options)
    }
    module.hot.accept("./promotion_rule.vue?vue&type=template&id=62aaf1c3&scoped=true", function () {
      api.rerender('62aaf1c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/promotion/pro_policy-copy/form/promotion_rule/promotion_rule.vue"
export default component.exports